export default {
  columns: {
    title: 'Titre',
    image: 'Image',
    button_url: 'URL du bouton',
    button_text: 'Texte du bouton',
    description: 'Description',
    visible: 'Visible',
    actions: 'Actions',
  },
  buttons: {
    create_post: 'Créer un post',
    edit: 'Modifier',
    delete: 'Supprimer',
    cancel: 'Annuler',
    confirm: 'Confirmer',
  },
  title: 'Posts en vedette',
  delete_confirmation: 'Voulez-vous vraiment supprimer ce post ?',
};
